module.exports = __webpack_public_path__ + "img/W-C46.5ff45462.jpg";